<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        @openFilter="$store.commit('openFilter')"
        :show_print="true"
        :show_filter="true"
      />
      <!-- End Breadcrumb -->

      <!-- Start Statistics Card-->
      <div class="row mb-5">
        <div class="col-lg-3 col-md-4 col-12">
          <stats-card
            :icon="'fal fa-handshake'"
            :title="'كل التسليمات'"
            :number="rows.length"
            :color="current_theme == 'dark' ? '#525e6e' : '#acc4d9'"
            :bgColor="'transparent'"
          ></stats-card>
        </div>
      </div>
      <!-- End Statistics Card-->

      <!-- Start Main Section -->
      <main class="main-table">
        <v-data-table
          class="thumb"
          :headers="headers"
          :items="rows"
          :search="search"
          :custom-filter="filterSearch"
          :loading="lodaing"
          :loading-text="$t('table.loadingData')"
          v-model="selected"
          :single-select="singleSelect"
          item-key="id"
          :items-per-page="rows.length"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- ====== Select row field ====== -->
          <!-- title -->
          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:[`item.title`]="{ item }">
            <v-chip color="red">
              {{ item.title }}
            </v-chip>
          </template>

          <!-- Select no data State -->
          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.desc`]="{ item }">
            <div class="_actions">
              <v-icon
                class="show"
                small
                @click="
                  modal.descriptionModalIsOpen = true;
                  setItemDesc(item.desc);
                "
              >
                fal fa-eye
              </v-icon>
            </div>
          </template>

          <template v-slot:[`item.notes`]="{ item }">
            <div class="_actions">
              <span v-if="item.notes == 'null' || item.notes == null">
                ----
              </span>
              <v-icon
                class="show"
                small
                v-else
                @click="
                  modal.notesModalIsOpen = true;
                  setItemNotes(item.notes);
                "
              >
                fal fa-eye
              </v-icon>
            </div>
          </template>

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions">
              <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
              <v-icon class="edit" small @click="editItem(item)">
                fal fa-edit
              </v-icon>
              <v-icon class="delete" small @click="deleteItem(item)">
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">{{
                  $t("table.deletedialog.areYouSure")
                }}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm"
                    >{{ $t("table.deletedialog.ok") }}
                    <span
                      class="btn_loader_model"
                      v-if="loadingBtnDialog"
                    ></span
                  ></v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">{{
                    $t("table.deletedialog.cancel")
                  }}</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Description Modal -->
            <DescModal
              :desc="selectedItemDesc"
              :handelModalApperance="modal.descriptionModalIsOpen"
              @close="closeDescModal"
            />

            <NotesModal
              :desc="selectedItemNotes"
              :handelModalApperance="modal.notesModalIsOpen"
              @close="closeNotesModal"
            />

            <!-- Row -->
            <v-row>
              <!-- Add & Delete -->
              <v-col cols="12" sm="4"> </v-col>
            </v-row>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>
      <!-- End Main Section -->
      <!-- Start Filter Menu -->
      <table-filter
        :show="$store.state.show_filter"
        @submit_filter="filterRows"
        @closeFilter="$store.commit('closeFilter')"
      ></table-filter>
      <!-- End Filter Menu -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "./../../../components/Charts/ChartComponent.vue";
import DescModal from "@/components/modals/DescriptionModal.vue";
import NotesModal from "@/components/modals/NotesModal.vue";

export default {
  name: "AllExpenses",

  components: {
    StatsCard,
    DescModal,
    NotesModal,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.deliverables.title"),
          disabled: false,
          href: "/deliverables",
        },
        {
          text: this.$t("breadcrumb.deliverables.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "كل التسليمات",
          number: "10",
        },
      ],

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // Custom Modal Data
      modal: {
        descriptionModalIsOpen: false,
        notesModalIsOpen: false,
      },
      selectedItemDesc: null,
      selectedItemNotes: null,
      // ========== Loding
      lodaing: false,
    };
  },

  computed: {
    current_theme() {
      return this.$store.getters["theme_module/current_theme"];
    },
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            value: "index",
            sortable: false,
            align: "center",
            width: 10,
          },
          {
            text: "القائم بالتسليم",
            value: "employee.name",
            sortable: false,
            align: "center",
          },
          {
            text: "إسم المستلم",
            value: "customer.name",
            sortable: false,
            align: "center",
          },
          {
            text: "رقم هاتف المستلم",
            value: "customer.phone",
            sortable: false,
            align: "center",
          },
          {
            text: "المبلغ",
            value: "amount",
            sortable: false,
            align: "center",
          },
          {
            text: "العملة",
            value: "currency.name_ar",
            sortable: false,
            align: "center",
          },
          {
            text: "الخزنة",
            value: "wallet.name",
            sortable: false,
            align: "center",
          },
          {
            text: "التاريخ",
            value: "created_at",
            sortable: false,
            align: "center",
          },
          {
            text: "وصف",
            value: "desc",
            sortable: false,
            align: "center",
          },
          {
            text: "ملاحظات",
            value: "notes",
            sortable: false,
            align: "center",
          },
          {
            text: "التحكم",
            value: "actions",
            sortable: false,
            align: "center",
            class: "showOnPrint",
            cellClass: "showOnPrint",
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.lodaing) {
        if (word != "all") {
          this.search = word;
        } else {
          this.search = "";
        }
        this.filterSearch();
      }
    },

    filterSearch(value, search, item) {
      return (
        value != null &&
        search != null &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      );
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/deliverables/add" });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({ path: "/deliverables/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `client/delivery/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("CRUD.Delete"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    setItemDesc(desc) {
      this.selectedItemDesc = desc;
    },
    setItemNotes(notes) {
      this.selectedItemNotes = notes;
    },
    closeDescModal() {
      this.modal.descriptionModalIsOpen = false;
    },
    closeNotesModal() {
      this.modal.notesModalIsOpen = false;
    },
    // ==================== End CRUD ====================

    // ================ Set Rows
    setRows() {
      this.lodaing = false;
      // this.rows = [
      //   {
      //     id: 1,
      //     receiverName: "Receiver Name",
      //     phoneNumber: "010668665423",
      //     deliverer: "Deliverer Name",
      //     amount: "7000",
      //     currency: "جنية مصرى",
      //     theLock: "Lock 1",
      //     date: "29-3-2022",
      //     desc: "Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test",
      //     notes:
      //       "Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test Test",
      //   },
      // ];
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "client/delivery",
      })
        .then((res) => {
          this.rows = res.data.data;
          this.table_length = this.rows.length;
          this.lodaing = false;
        })
        .catch((err) => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  created() {
    // Set Rows
    this.setRows();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
};
</script>

<style lang="scss" scoped></style>
